import React from 'react';

/**
 * Minimal, safe `**bold**` renderer — never `dangerouslySetInnerHTML`. Lifted
 * out of `ContactIntelPanel.tsx` (D11) so `AccountIntelSummaryView` (plan
 * `plans/2026-09-23-002-rep-prompt-overrides-and-account-intelligence-summary-plan.md`
 * U8) can reuse it rather than duplicate it.
 */
export function renderBoldText(text: string): React.ReactNode[] {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      // oxlint-disable-next-line no-array-index-key -- parts are positional segments of one fixed split of the streamed text, re-derived (never reordered/spliced) on every render; index is the only stable identity here.
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    // oxlint-disable-next-line no-array-index-key -- see rationale above.
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}
